import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { fetchSalesInvoices, fetchSalesInvoice } from "../../thunks/salesInvoicesThunk";

const dataAdapter = createEntityAdapter();
const dataView = dataAdapter.getSelectors(state => state.datasources.salesInvoiceDetails);
const salesInvoiceDetailsSliceDatasource = createSlice({
	name: "datasources/salesInvoiceDetails",
	initialState: dataAdapter.getInitialState(),
	reducers: {
		unloaded: (salesInvoiceDetails, _) => {
			dataAdapter.removeAll(salesInvoiceDetails, {});
		}
	},
	extraReducers: builder => {
		builder
			.addCase(fetchSalesInvoices.fulfilled, (salesInvoiceDetails, action) => {
                if (action.payload.hasOwnProperty("salesInvoiceDetails")) {
                    dataAdapter.upsertMany(salesInvoiceDetails, action.payload.salesInvoiceDetails);
                }
			})
			.addCase(fetchSalesInvoice.fulfilled, (salesInvoiceDetails, action) => {
                if (action.payload.hasOwnProperty("salesInvoiceDetails")) {
                    dataAdapter.upsertMany(salesInvoiceDetails, action.payload.salesInvoiceDetails);
                }
			});
	}
});
export default salesInvoiceDetailsSliceDatasource.reducer;

export const unloadSalesInvoiceDetails = () => salesInvoiceDetailsSliceDatasource.actions.unloaded();
export const getSalesInvoiceDetailEntities = dataView.selectEntities;